export default __webpack_public_path__ + "static/media/medienmanager.03552b24.svg";